
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type TireFacetsDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function TireFacetsDialogRT(): TemplateResult<TireFacetsDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
        'className': 'close',
        'data-cm-role': 'close'
    }, _createElement('svg', {
        'className': 'cm_icon cm_icon-times',
        'height': '20px',
        'role': 'img',
        'viewBox': '0 0 22 22'
    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))), _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-body' }, _createElement('div', { 'className': 'dialog_title' }, 'Shop Tires'), _createElement('div', { 'className': 'dialog_info' }, _createElement('div', { 'className': 'dialog_info-text' }, 'How to find my tire size?'), _createElement('img', {
        'className': 'dialog_info-image',
        'src': 'https://client.convermax.com/static/img/how-to-find-my-tire-size.png',
        'alt': 'How to find my tire size?',
        'onError': e => e.target.closest('.dialog_info').style.display = 'none'
    })), [this.StaggeredTireFacetPanel(function () {
            function repeatSelects1(selectedFacetsAmount, hasSelection, selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField2() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                !hasSelection ? [_createElement('option', {
                                        'value': window.Convermax.tireFacetsPreselect[this.field],
                                        'key': window.Convermax.tireFacetsPreselect[this.field]
                                    }, '\n            ', window.Convermax.tireFacetsPreselect[this.field], '\n          ')] : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown' }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': !hasSelection ? window.Convermax.tireFacetsPreselect[this.field] : this.firstSelectedTerm || '',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, scopePopularEntriesUnpopularEntriesIsPopularField2.apply(this, []))));
                    }, { count: undefined })];
            }
            function scopeHasSelection2(selectedFacetsAmount) {
                var hasSelection = this.hasSelection;
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container cm_vehicle-widget_select-container--front  cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this, selectedFacetsAmount, hasSelection))
                ]);
            }
            function onChange3(selectedFacetsAmount, e) {
                e.target.closest('label').classList.toggle('cm_show-rear', e.target.checked);
            }
            function repeatSelects4(selectedFacetsAmount, hasSelection, selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField2() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                !hasSelection ? [_createElement('option', {
                                        'value': window.Convermax.tireFacetsPreselect[this.field],
                                        'key': window.Convermax.tireFacetsPreselect[this.field]
                                    }, '\n            ', window.Convermax.tireFacetsPreselect[this.field], '\n          ')] : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown' }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': !hasSelection ? window.Convermax.tireFacetsPreselect[this.field] : this.firstSelectedTerm || '',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, scopePopularEntriesUnpopularEntriesIsPopularField2.apply(this, []))));
                    }, { count: undefined })];
            }
            function scopeHasSelection5(selectedFacetsAmount) {
                var hasSelection = this.hasSelection;
                return _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_vehicle-widget_select-container cm_vehicle-widget_select-container--rear  cmRepeater_selects',
                        'key': '29173'
                    },
                    _map(this.selects, repeatSelects4.bind(this, selectedFacetsAmount, hasSelection))
                ]);
            }
            function onClick6(selectedFacetsAmount, e) {
                {
                    window.Convermax.submitPackagesFacetsSelection(e, this.selection, this.hasSelection);
                }
            }
            function scopeSelectedFacetsAmount7() {
                var selectedFacetsAmount = this.selection ? Object.values(this.selection).filter(Boolean).length : 0;
                return _createElement('div', { 'className': 'cm_vehicle-widget_body' }, scopeHasSelection2.apply(this, [selectedFacetsAmount]), selectedFacetsAmount > 3 || selectedFacetsAmount === 0 || selectedFacetsAmount === 3 && !this.hasFullSelection ? [
                    _createElement('label', {
                        'onChange': onChange3.bind(this, selectedFacetsAmount),
                        'className': 'cm_select-toggle',
                        'key': '29171'
                    }, _createElement('input', {
                        'type': 'checkbox',
                        'id': 'toggle',
                        'hidden': true
                    }), '\n                Add a Different Rear Size\n              '),
                    scopeHasSelection5.apply(this, [selectedFacetsAmount])
                ] : null, _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('button', {
                    'onClick': this.clear,
                    'className': 'cm_button cm_button__secondary cm_vehicle-widget_button',
                    'disabled': this.disableClear
                }, '\n                Reset\n              '), _createElement('button', {
                    'onClick': onClick6.bind(this, selectedFacetsAmount),
                    'className': 'cm_button cm_button__primary cm_vehicle-widget_button'
                }, '\n                Search\n              ')));
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicle-widget__dialog--tire cm_StaggeredTireFacetPanel' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, scopeSelectedFacetsAmount7.apply(this, [])));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])));
}
        export const componentNames = ["cm:StaggeredTireFacetPanel"]